const problems = [
  { icon: "ri-eye-off-line", label: "Poor visibility" },
  { icon: "ri-team-line", label: "Disconnected teams" },
  { icon: "ri-file-list-3-line", label: "Manual reporting" },
  { icon: "ri-shield-user-line", label: "Weak accountability" },
  { icon: "ri-money-dollar-circle-line", label: "Revenue leakage" },
  { icon: "ri-time-line", label: "Slow decisions" },
];

export default function ProblemsSection() {
  return (
    <section className="relative py-16 md:py-24 bg-graphite-850">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-4xl mx-auto text-center mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
            Growing Businesses Should Not Run on{" "}
            <span className="text-emerald-accent">Fragmented Tools</span>
          </h2>
          <p className="text-silver-300 text-base md:text-lg max-w-2xl mx-auto">
            Most businesses lose time, money, and momentum by stitching together disconnected tools.
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4 max-w-6xl mx-auto">
          {problems.map((p) => (
            <div
              key={p.label}
              className="glass-card p-5 md:p-6 flex flex-col items-center text-center gap-3 group"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-graphite-800 group-hover:bg-emerald-accent/10 transition-colors">
                <i className={`${p.icon} text-xl md:text-2xl text-emerald-accent group-hover:scale-110 transition-transform duration-300`} />
              </div>
              <span className="text-sm md:text-base font-medium text-white group-hover:text-emerald-soft transition-colors duration-300">{p.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}